// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2OccX","tab":"Tabs_tab__21SUV","tabActive":"Tabs_tabActive__2EnYU"};